import React, { lazy } from 'react';

export const LazyNotificationPreview = lazy(() => import('../NotificationPreview'));